export const selectSortColumn = (state) => state.mainReducer.sort_column;
